import { render, staticRenderFns } from "./SelecionarAdministradoraDialog.vue?vue&type=template&id=51a56f2e&"
import script from "./SelecionarAdministradoraDialog.vue?vue&type=script&lang=js&"
export * from "./SelecionarAdministradoraDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports